import { Navigate, type RouteObject } from "react-router";
import { STAFF_ROUTES } from "@/src/staff/constants/staff-routes";
import { StaffGuard } from "@/src/staff/guards/staff-guard";
import { CommunityDetailLayout } from "@/src/staff/layouts/community-detail-layout";
import { StaffLayout } from "@/src/staff/layouts/staff-layout";

export const staffRoutes: RouteObject = {
	element: <StaffGuard />,
	children: [
		{
			element: <StaffLayout />,
			children: [
				{
					path: STAFF_ROUTES.COMMUNITIES,
					lazy: async () => {
						const { default: CommunitiesListPage } = await import("@/src/staff/pages/communities-list-page");
						return { Component: CommunitiesListPage };
					},
				},
				{
					path: STAFF_ROUTES.COMMUNITY_DETAIL,
					element: <CommunityDetailLayout />,
					children: [
						{
							index: true,
							element: <Navigate to="members" replace />,
						},
						{
							path: "members",
							lazy: async () => {
								const { default: CommunityMembersTab } = await import("@/src/staff/pages/community-members-tab");
								return { Component: CommunityMembersTab };
							},
						},
						{
							path: "mobile-app",
							lazy: async () => {
								const { default: CommunityMobileAppTab } = await import("@/src/staff/pages/community-mobile-app-tab");
								return { Component: CommunityMobileAppTab };
							},
						},
					],
				},
			],
		},
	],
};
